import { z } from 'zod';

export const NewsletterSubscribeBodySchema = z.object({
  email: z.string().email(),
});

export const NewsletterSubscribeSuccessSchema = z.object({
  ok: z.literal(true),
});

export const NewsletterSubscribeErrorSchema = z.object({
  ok: z.literal(false),
  error: z.string(),
});

export type NewsletterSubscribeRoute = never;
